export default __webpack_public_path__ + "static/media/Path3460.70f749b1.svg";